/** @format */

import { useEffect } from "react";
import { Container } from "../../components/layouts/Container";
import useGTMHooks from "../../hooks/useGTMHooks";
import BcartEconomicEstimateElement from "../../components/ui_elements/bcart/Economic/EconomicEstimateElement";

const BcartRedirectEconomic = ({ redirect }: { redirect?: boolean }) => {
  const { pushDataLayerHandler } = useGTMHooks();
  useEffect(() => {
    pushDataLayerHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Container isLogin={true} background={"default"} align={"top"} redirect={redirect}>
      <BcartEconomicEstimateElement redirect={redirect} />
    </Container>
  );
};

export default BcartRedirectEconomic;
